"use strict";
/* !
 * (c) Copyright 2025 Palantir Technologies Inc. All rights reserved.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Size = void 0;
/* eslint-disable sort-keys */
/** The rendering size of a component. */
exports.Size = {
    SMALL: "small",
    MEDIUM: "medium",
    LARGE: "large",
};
//# sourceMappingURL=size.js.map